import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

type BlockCardType = {
  borderLeft: boolean;
  reverse?: boolean;
};

export const Content = styled.div<BlockCardType & LayoutProps & SpaceProps>`
  padding: ${tokens.space.looser} ${tokens.space.loosest};
  border-left: ${({ borderLeft = false }): string | false =>
    borderLeft && `border-left: 10px solid ${tokens.colors.primary}`};
  border-radius: ${tokens.radii.m};
  background: ${tokens.colors.white};
  box-shadow: 0px 7px 21px rgba(64, 64, 64, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  flex-direction: ${({ reverse }): string => (reverse ? 'row-reverse' : 'row')};

  ${layout};
  ${space};

  ${tokens.mediaQueries.s} {
    flex-direction: column;
    padding: ${tokens.space.larger} ${tokens.space.large};
  }
`;
